// Loads localized UI strings from window.__APP_UI_STRINGS (declared in
// /public/ui_strings.js, loaded via a <script> tag in index.html) and
// merges the values into the exported objects declared in constants.js.
// Because those objects are mutated in place, every consumer that imports
// them keeps its existing reference and automatically sees the loaded
// values — no call-site changes required.
//
// Using a <script> tag (instead of fetching JSON) makes the file editable
// in place after build and works even when index.html is opened directly
// from the local filesystem via file://.
//
// Default values stay in constants.js and are used whenever the global
// is missing or malformed.
import {
    MAIN_MENU,
    LANG_TITLES_RED,
    LEGEND_BTNS,
    SELECTED,
    DOWNLOAD,
    TABLE,
} from './constants';

const TARGETS = {
    MAIN_MENU,
    LANG_TITLES_RED,
    LEGEND_BTNS,
    SELECTED,
    DOWNLOAD,
    TABLE,
};

/**
 * Replace the contents of `target` with the contents of `source` while
 * preserving the original reference. Handles both plain objects and arrays.
 */
const mergeInPlace = (target, source) => {
    if (Array.isArray(target) && Array.isArray(source)) {
        target.length = 0;
        target.push(...source);
        return;
    }
    if (target && typeof target === 'object' && source && typeof source === 'object') {
        for (const key of Object.keys(target)) {
            delete target[key];
        }
        Object.assign(target, source);
    }
};

/**
 * Read window.__APP_UI_STRINGS and overlay its contents onto the shared
 * constants. Returns a Promise for API consistency; resolves synchronously.
 */
export const loadUiStrings = async () => {
    try {
        const data = typeof window !== 'undefined' ? window.__APP_UI_STRINGS : null;
        if (!data || typeof data !== 'object') {
            console.warn('uiStrings - window.__APP_UI_STRINGS is not set, using defaults');
            return;
        }
        for (const [key, value] of Object.entries(data)) {
            if (TARGETS[key] !== undefined) {
                mergeInPlace(TARGETS[key], value);
            }
        }
    } catch (err) {
        console.error('uiStrings - failed to read window.__APP_UI_STRINGS, using defaults:', err);
    }
};
